import React, { Component } from "react";
import { useTranslation } from 'react-i18next';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log("Error", errorInfo);
    this.setState({
      hasError: true
    });
  }
  render() {
    if (this.state.hasError) {
      return <ErrorMessage />;
    }
    return this.props.children;
  }
}

const ErrorMessage = () => {
  const { t } = useTranslation();
  return <h3>{t('Something went wrong!!')}</h3>;
};

export default ErrorBoundary;
